/**
 * @generated SignedSource<<ecc0e43c0678437f749dd5adcc9ed695>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SettingsTaskMonitoringDefaultQuery$variables = {};
export type SettingsTaskMonitoringDefaultQuery$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"SettingsTaskMonitoringDefault_viewer">;
  } | null;
};
export type SettingsTaskMonitoringDefaultQuery = {
  variables: SettingsTaskMonitoringDefaultQuery$variables;
  response: SettingsTaskMonitoringDefaultQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "settings_task_monitoring_default"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"settings_task_monitoring_default\")"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SettingsTaskMonitoringDefaultQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SettingsTaskMonitoringDefault_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SettingsTaskMonitoringDefaultQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultUseTaskOwner",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultUseTaskFollowers",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "de4372d130681a2cf561bc3111040d33",
    "id": null,
    "metadata": {},
    "name": "SettingsTaskMonitoringDefaultQuery",
    "operationKind": "query",
    "text": "query SettingsTaskMonitoringDefaultQuery {\n  viewer {\n    actualPersonId\n    component(name: \"settings_task_monitoring_default\")\n    ...SettingsTaskMonitoringDefault_viewer\n    id\n  }\n}\n\nfragment SettingsTaskMonitoringDefault_viewer on Viewer {\n  actualPersonId\n  id\n  company {\n    id\n    defaultUseTaskOwner\n    defaultUseTaskFollowers\n  }\n}\n"
  }
};
})();

(node as any).hash = "23539f2a46e73bad90b395f7eb520cf7";

export default node;
